:host {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
}

.icon-wrapper { padding-right: 10px; }

.brand-icon { display: block; width: 25px; }

.info { flex: 1; }

.number {
  color: #444;
  line-height: 18px;
  font-weight: bold;
  text-transform: capitalize;
}

.expiration-date {
  color: #888;
  font-size: 12px;
  padding-top: 3px;
}

.expired { color: red; }